import * as React from "react";

import { cn } from "./utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "resize-none border-white/10 placeholder:text-white/40 focus-visible:border-primary focus-visible:ring-primary/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex field-sizing-content min-h-16 w-full rounded-xl border bg-black/20 text-white px-3 py-2 text-base transition-[color,box-shadow] outline-none focus-visible:ring-[3px] hover:border-white/20 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm mb-6",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
